import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ThermoPackage, KeyValuePair } from '../../../models/';
import { IThermoPackageService, ILoggerService } from '../../../services/';

class ThermoPackageCompoundsListController implements angular.IComponentController {
    formController: angular.IFormController;
    fractionTypes: KeyValuePair<number, string>[];
    isEditMode: boolean;
    isLoading: boolean;
    loadingMessage: string;
    packageName: string;
    thermoPackage: ThermoPackage;
    total: number;

    static $inject = ['$stateParams', '$translate', 'thermoPackageService', 'loggerService'];

    constructor(
        private _$stateParams: angular.ui.IStateParamsService,
        private _$translate: angular.translate.ITranslateService,
        private _thermoPackageService: IThermoPackageService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.fractionTypes = [
            { key: 0, value: 'Mass fraction' },
            { key: 1, value: 'Molar fraction' }
        ];

        // ... or by StateParams
        if (this.packageName === undefined) {
            this.packageName = this._$stateParams.name;
        }

        // get the package by its name
        if (this.packageName) {
            this.isLoading = true;
            this._thermoPackageService
                .getByName(this.packageName)
                .then((data) => {
                    this.thermoPackage = data.packageInformation;
                    this.thermoPackage.compounds.forEach((x, index) => {
                        x.index = index;
                        x.externUrl = this._$translate.instant('CAS URL', { 'casNumber': x.casNumber });
                    });
                    this.thermoPackage.compounds.forEach((c: any) => {
                        c.percentageFraction = c.defaultFraction * 100;
                    });
                    this.total = _.sumBy(this.thermoPackage.compounds, (c: any) => c.percentageFraction);
                })
                .finally(() => this.isLoading = false);
        }
    }
    
    hasError(compound) {
        const object = this.formController[`compound${compound.index}`];
        if (object) {
            return object.$invalid;
        }
    }

    error(compound) {
        const object = this.formController[`compound${compound.index}`];
        if (object) {
            return object.$error;
        }
    }

    save() {
        this.isLoading = true;
        this.loadingMessage = 'Updating compositions';
        this.thermoPackage.compounds.forEach((c: any, i) => {
            c.defaultFraction = c.percentageFraction / 100;
        });
        this._thermoPackageService.update(this.thermoPackage)
            .then(() => this._loggerService.logSuccess('Compositions updated.'))
            .catch(() => this._loggerService.logError('Failed to update compositions.'))
            .finally(() => this.isLoading = false);
    }

    cancel() {
        this.formController.$cancel();
        this.formController.$setPristine();
    }

    checkTotal(compound, $data) {
        let total = 0;
        this.thermoPackage.compounds.forEach((c: any) => {
            if (c.name === compound.name) {
                c.percentageFraction = $data;
            }
            total += c.percentageFraction;
        });
        this.total = total;
        this.formController['total'].$setValidity('total', this.total === 100);
    }

    getTotalClass() {
        const result: any = {};
        if (this.total < 99 || this.total > 101) {
            result['alert alert-danger'] = true;
        } else if (this.total !== 100) {
            result['alert alert-warning'] = true;
        }
        return result;
    }

    fractionName() {
        let result = '';
        if (this.thermoPackage) {
            const fraction = !this.fractionTypes ? { value: '' } : this.fractionTypes[this.thermoPackage.fractionType];
            result = fraction.value;
        }
        return result;
    }
}

export const wtThermoPackageCompoundsList: ComponentDefinition = {
    componentId: 'wtThermoPackageCompoundsList',
    controller: ThermoPackageCompoundsListController,
    template: require('./thermoPackageCompoundsList.component.html'),
    controllerAs: 'vm',
    bindings: {
        packageName: '<',
        isEditMode: '<',
        formController: '='
    }
};